document.addEventListener("DOMContentLoaded", function () {
  const dropdownButton = document.querySelector('.dropbtn');
  const dropdownContent = document.querySelector('.dropdown-content');
  const tabs = document.querySelectorAll('.nav-link-bundle');
  const firstItem = tabs[0];
  const selectedText = firstItem.textContent;
  dropdownButton.textContent = selectedText;

  tabs.forEach(item => {
    item.addEventListener('click', function () {
      const selectedText = item.textContent;
      dropdownButton.textContent = selectedText;
    });
  });

  // Event listeners for tabs and dropdown
  tabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const tabId = tab.getAttribute('data-tab');
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      document.querySelectorAll('.main-tab-content').forEach(content => {
        content.classList.remove('active');
        content.classList.add('hidden');
      });

      const matchingTabContents = document.querySelectorAll(`.main-tab-content[id="${tabId}"]`);
      matchingTabContents.forEach(content => {
        content.classList.remove('hidden');
        content.classList.add('active');
      });
    });
  });

  const dropbtn = document.querySelector('.dropdown');
  dropdownButton.addEventListener('click', function () {
    dropdownContent.classList.toggle('show');
    dropbtn.classList.toggle('active'); // Toggle active class instead of always adding
  });
  
  window.onclick = function (event) {
    if (!event.target.matches('.dropbtn')) {
      const dropdowns = document.getElementsByClassName('dropdown-content');
      for (let i = 0; i < dropdowns.length; i++) {
        const openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
          dropbtn.classList.remove('active'); // Remove active class
        }
      }
    }
  };
  

  let tabButtons = document.querySelectorAll('.ingredient-title');
  tabButtons.forEach(button => {
    button.addEventListener('click', function () {
      var tabContents = button.closest('.main-tab-content').querySelectorAll(`.ingredient-image`);
      var btns = button.closest('.main-tab-content').querySelectorAll('.ingredient-title');
      btns.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      var tab = button.dataset.tab.trim();
      tabContents.forEach(content => {
        var contenrdata = content.dataset.tabContent.trim();
        if (contenrdata == tab) {
          content.classList.add('active');
          content.classList.remove('hidden');
        } else {
          content.classList.remove('active');
          content.classList.add('hidden');
        }

      });

    });
  });
});
